/**
 * Tipos do bounded context "Companion Identity" — L1-L3 da Fase 5.
 *
 * O Companion é uma relação, não o LLM. O aprendiz escolhe como
 * quer se relacionar com ele: nome, voz, visual. Esses são apenas
 * affordances de UX (Princípio XI: nunca expor o LLM).
 *
 * Constitucional:
 * - Princípio XI (Companion ≠ LLM): o nome/voz/visual é do
 *   Companion Intelectual, não do modelo de linguagem.
 * - P-UX-01 (Calm by default): tudo opt-in.
 * - Princípio X (Dignidade): zero manipulação emocional; apego
 *   saudável é OK, dependência não.
 */

export type CompanionVoiceId = "calm-1" | "calm-2" | "calm-3";
export type CompanionVisualId = "minimal-1" | "minimal-2" | "minimal-3" | "none";

export interface CompanionIdentity {
  /** Nome dado pelo aprendiz. String vazia = sem nome. */
  name: string;
  voice: CompanionVoiceId;
  visual: CompanionVisualId;
}

export const DEFAULT_IDENTITY: CompanionIdentity = {
  name: "",
  voice: "calm-1",
  visual: "minimal-1",
};

export const NAME_SUGGESTIONS = [
  "Lume",
  "Eco",
  "Bússola",
  "Farol",
  "Brilho",
  "Vela",
  "Raiz",
  "Semente",
  "Outro",
];
